
<div *ngIf="menu">
  <div class="d-flex align-items-center justify-content-end m-0" *ngFor="let row of menu?.rows ; trackBy:rowTrackBy">
    <div  class="d-flex justify-content-center flex-column" *ngFor="let button of row?.buttons ; trackBy:buttonTrackBy" [ngClass]="isfull? 'p-0': fontSmaller? 'ps-1 py-1 pe-1':'p-1'" >
      <app-button-icon  [fontSmaller]="fontSmaller" [fontResize]="fontResize" *ngIf="button?.button_form === button_form?.ICON" [button]="button"  [row_id]="row?.row_id"  [colors]="colors" [no_buttons]="row.buttons.length" (click)="onClick(button)"></app-button-icon>
      <app-button-context-menu  [fontSmaller]="fontSmaller" [fontResize]="fontResize" *ngIf="button?.button_form === button_form?.CONTEXT_MENU" [button]="button"  [row_id]="row?.row_id"  [colors]="colors" [no_buttons]="row.buttons.length" (click)="onClick(button)"></app-button-context-menu>
    </div>
  </div>
</div>
<!--
<div>
  <img
  *ngIf="image"
    [src]="image"
    [class.boreder-bottom-16]="roundedBottom"
    class="img-fluid"
    [alt]="title"
  />
</div> -->


